import { isObject } from '../is-object';

export function objToFormData(data: Record<string, any>) {
  const formData = new FormData();

  function appendToFormData(key: string, value: any) {
    if (Array.isArray(value)) {
      value.forEach((item) => appendToFormData(`${key}[]`, item));
    } else if (isObject(value)) {
      Object.entries(value).forEach(([nestedKey, nestedValue]) => appendToFormData(`${key}[${nestedKey}]`, nestedValue));
    } else {
      formData.append(key, value);
    }
  }

  for (const [key, value] of Object.entries(data)) {
    if (value !== undefined) appendToFormData(key, value);
  }

  return formData;
}
